<template>
    <form>

            <div class="row">
                <div class="col-12">
                    <h2>{{$t('form.experience.header_main')}}</h2>
                    <p>{{$t('form.experience.label_info')}}</p>
                </div>
            </div>

            <button v-if="hidden"  class="button--cta margin-bottom" v-on:click= "hidden = !hidden" :class="{'loading': submit.busy}" type="button">
                         {{$t('form.experience.button_review')}}
            </button>

            <div v-if="!hidden" transition="expand" class="block">
                <div class="form__group">
                    <input type="text" required class="form__input--text" :placeholder="$t('form.experience.placeholder_title')" v-model="title">
                    <div v-if="error.title" class="alert--error" > {{$t('form.experience.error.title')}}</div>
                </div>
                <div class="form__group" >
                     <textarea type="text" required class="form__input--textarea border_dark" id="review_form" :placeholder="$t('form.experience.placeholder_review')" v-model="review" />
                     <div v-if="error.review" class="alert--error"> {{$t('form.experience.error.review')}}</div>
                </div>
                <div class="form__group">
                    <star-rating :increment="0.5" v-model ="rating" v-bind:star-size="30" active-color="#6d9ee1" v-bind:show-rating = "false"></star-rating>
                    <div v-if="error.rating" class="alert--error"> {{$t('form.experience.error.rating')}}</div>
                </div>

                <div class="form__buttons">
                <button v-on:click="submitExperience" type="button" class="button--cta" :class="{'loading': submit.busy}">
                         {{$t('form.experience.button_review_submit')}}
                </button>
                 </div>
            </div>
    </form>
</template>

<script>
    import Vue from 'vue';
    import {Component} from 'vue-property-decorator';
    import StarRating from 'vue-star-rating';
    import {
        FETCH_EXPERIENCES,
        SUBMIT_EXPERIENCE
    } from '../../store/modules/experiences';


    @Component({
        components: {StarRating}
    })
    export default class ExperienceFrom extends Vue {
        hidden = null;
        title = null;
        review = null;
        rating = null;
        submit = {busy: false, error: false};
        error = {
            title: false,
            review: false,
            rating: false
        }

        created() {
            this.hidden = true;
        }

        validate(){
            this.error.title = false;
            this.error.review = false;
            this.error.rating = false;
            if (this.title && this.review && this.rating){
                return true;
            } else {
                if (!this.title) {
                    this.error.title = true;
                }
                if (!this.review) {
                    this.error.review = true;
                }
                if (!this.rating){
                    this.error.rating = true;
                }
            }
        }

        async submitExperience() {
            if (this.validate()) {
                this.submit.busy = true;
                try {
                    let payload = {
                        title: this.title,
                        rating: this.rating * 2,
                        text: this.review,
                    };
                    await this.$store.dispatch(SUBMIT_EXPERIENCE, payload);
                    this.$notify.success(this.$t('form.experience.notify_success'));
                    this.hidden = true;
                    this.title = null;
                    this.review = null;
                    this.rating = null;
                    this.$emit('update');
                } catch (e) {
                    this.$notify.error(this.$t('form.experience.notify_failure'));
                } finally {
                    this.submit.busy = false;
                }
            }
        }
    }
</script>

<style>

    .red_border{
         border: solid 1px red !important;
    }

    .form__input--text{
        border-bottom: solid 1px black;
        padding: 10px;
    }

    textarea {
        font-family: sans-serif;
    }
    .margin-bottom{
        margin-bottom: 20px !important;
    }

    .expand-transition {
        transition: all .3s ease;
        height: 30px;
        padding: 10px;
        background-color: #eee;
        overflow: hidden;
    }

    .expand-enter, .expand-leave {
        height: 0;
        padding: 0 10px;
        opacity: 0;
    }

</style>





// WEBPACK FOOTER //
// src/components/forms/ExperienceForm.vue